import withInputFields from "../../helpers/inputfields";
import withReactiveFields from "../../helpers/reactivefields";
import { USES_CHARGE_POLLING } from "../../../../charge/flags";
import { getValueAtPath, withProperties } from "../../../../utils";
import { selectNetworkFromList } from "../../../../collections/mobilemoneynetworks";
import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";

import InitView from "./views/init";
import ConfirmView from "./views/confirm";
import RedirectView from "../../common/redirect";
import withCountdownTimer from "../../helpers/countdowntimer";
import PendingView from "../../common/pending";

const METHOD = 'mobilemoneyzambia';
const METHOD_NAME = 'Mobile Money';
const CHARGE_MODE = USES_CHARGE_POLLING;

const VIEWS = [ InitView, ConfirmView ];

function mount() {
  return (dispatch) => {
    // Some logic here to determine the view to show instead of
    // always showing the form (first) view, nd also other stuffs
    // like fee check, limit check, etc.
    getChargeLimit.call(this, () => {
      const VIEW = (
        this.REDIRECT_URL && (RedirectView || (this.REDIRECT_URL = null))
      ) || InitView;
      
      VIEW && VIEW.activate.call(this);
    });

    getChargeFee();
  };
}

function getChargeData() {
  return ({
    is_mobile_money_gh: true,
    payment_type: 'mobilemoneygh'
  });
}

function getViewsContext(data, store) {
  const TIMER_DURATION = 5 * 60;
  const NETWORKS = getValueAtPath(data, 'mobilemoney_networks[ZM]');
  const REACTIVE_FIELDS = ['REDIRECT_URL', 'CURRENT_TIME', 'CAN_SWITCH_TO_CONFIRM'];
  const $context = withReactiveFields(Object.create(null), ...REACTIVE_FIELDS);

  $context.$subscribe('CAN_SWITCH_TO_CONFIRM', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue || oldValue === currentValue) && currentValue === true && typeof currentValue === 'boolean') {
          ConfirmView && ConfirmView.activate(() => {
          setTimeout(() => {
              $context.$charge.poll($context.pollConfig);
          }, 0);
          });
      }
      })
  })

  $context.$subscribe('REDIRECT_URL', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue && oldValue === currentValue) && currentValue instanceof URL) {
        RedirectView && RedirectView.activate.call($context);
      }
    }, 0);
  });

  withInputFields($context, {
    phone: getValueAtPath(data, 'phone') || null,
    network: {
      options: NETWORKS,
      selector: selectNetworkFromList.bind($context, NETWORKS),
      defaultValue: getValueAtPath(data, 'mobilemoney_network') || null
    }
  });

  $context.$inputs.$subscribe('network', (currentValue, oldValue) => {
    setTimeout(() => {
      const { currency, method  } = $context.STATE;
      if (oldValue !== currentValue && currency.current === 'ZMW' && method.current === 'mobilemoneyzambia') {        
        setTimeout(() => {
          getChargeFee();
        }, 0);
      }
    }, 0);
  });

  withProperties($context, {
    TIMER_DURATION,
    $resetContext() {
      $context.REDIRECT_URL = null;
    },
    INIT_VIEW: callback => {
      InitView && InitView.activate(callback);
    }
  });

  return withCountdownTimer($context, {
    duration: TIMER_DURATION,
    onTick() { $context.CURRENT_TIME = $context.$timer.current },
    onFinish() {
      if ($context.$charge.cancel()) {
          $context.$timer && $context.$timer.clear();
          $context.CURRENT_TIME = null;
          $context.reference = null;
          $context.$resetContext();
          setTimeout(() => PendingView && PendingView.activate.call($context), 10)
      }
    }
  })
}

export {
  METHOD,
  METHOD_NAME,
  CHARGE_MODE,
  VIEWS,
  mount,
  getChargeData,
  getViewsContext
}
